import {
	handleOauth2RedirectError,
	handleOauth2RedirectErrorWithProxy,
} from '../api/consumerDataPullSessionApi'
import { decodeBase64State } from './stateDecoder'

function tryGetreceivedIdentifier(queryParameters: any) {
	if(queryParameters?.state) {
		return queryParameters?.state
	}

	if(queryParameters?.keyid) {
		return queryParameters?.keyid
	}

	return null
}

export const oauth2RedirectFailureHandler = async (
	queryParameters: any,
): Promise<boolean> => {
	const isFailure = !!(queryParameters?.error) || failureBySuccessParameter(queryParameters?.success)
	const receivedIdentifier = tryGetreceivedIdentifier(queryParameters)

	if (isFailure) {
		//
		const decodedBase64State = decodeBase64State(receivedIdentifier)
		if (decodedBase64State != null) {
			try {
				await handleOauth2RedirectErrorWithProxy(
					decodedBase64State.url,
					decodedBase64State.keyId,
					{
						error: queryParameters.error,
						errorDescription: queryParameters.errorDescription,
						errorUri: queryParameters.errorUri,
					},
				)
			} catch {
				return true
			}
		}

		try {
			await handleOauth2RedirectError(receivedIdentifier, {
				error: queryParameters.error,
				errorDescription: queryParameters.errorDescription,
				errorUri: queryParameters.errorUri,
			})
		} catch {
			return true
		}

		return true
	}

	return false
}

export const handleNordeaRedirectFailure = async (queryParameters: any): Promise<boolean> => {
	const isFailure = !queryParameters?.code
	const receivedIdentifier = queryParameters?.state
	if (isFailure) {
		const errorMessage = queryParameters.httpmessage;
		const errorDescription = decodeURI(queryParameters.moreinformation)

		const decodedBase64State = decodeBase64State(receivedIdentifier)
		if (decodedBase64State != null) {
			try {
				await handleOauth2RedirectErrorWithProxy(
					decodedBase64State.url,
					decodedBase64State.keyId,
					{
						error: errorMessage,
						errorDescription: errorDescription,
						errorUri: queryParameters.errorUri,
					},
				)
			} catch {
				return true
			}
		}

		try {
			await handleOauth2RedirectError(receivedIdentifier, {
				error: errorMessage,
				errorDescription: errorDescription,
				errorUri: queryParameters.errorUri,
			})
		} catch {
			return true
		}

		return true
	}

	return false
}

function failureBySuccessParameter(successParameter?: string): boolean {
	if(successParameter) {
		return successParameter?.toLowerCase() === 'false'
	}

	return false;
}
